const EGkProgressState = {
  OPEN: { german: "Offen", english: "Open" },
  IN_PROGRESS: { german: "In Bearbeitung", english: "In Progress" },
  DONE: { german: "Erledigt", english: "Done" },
};

export default EGkProgressState;
